import api from './axios';

export async function subscribeNewsletter(payload) {
  const { data } = await api.post('/newsletter', payload);
  return data;
}

export async function fetchNewsletters(params = {}) {
  const { data } = await api.get('/newsletter', { params });
  return data.newsletters || [];
}

export async function exportNewsletters(params = {}) {
  const response = await api.get('/newsletter/export', {
    params,
    responseType: 'blob',
  });
  return response.data;
}
